<template>
  <section>
    <div class="photos-row" @click="openFullscreen()">
      <div
        v-for="(photo, index) in loadedPhotos.slice(0, 3)"
        :key="index"
        :class="{ last: index === 2 }"
        class="photo-wrapper"
      >
        <img
          v-if="$isDesktop"
          :loading="useLazyImages ? 'lazy' : 'eager'"
          :src="`/_cfi/cdn-cgi/image/format=auto,fit=cover,quality=80,w=264,h=198${photo.url.masterImage}`"
          :srcset="`
            /_cfi/cdn-cgi/image/format=auto,fit=cover,quality=80,w=264,h=198${photo.url.masterImage} 264w,
            /_cfi/cdn-cgi/image/format=auto,fit=cover,quality=70,w=360,h=270${photo.url.masterImage} 360w,
            /_cfi/cdn-cgi/image/format=auto,fit=cover,quality=50,w=720,h=540${photo.url.masterImage} 720w
          `"
          :alt="capitalize(photoCaptionAltFormatter(photo.caption))"
          sizes="264px"
          width="264"
          height="198"
          @imageLoadingError="handlePhotoLoadingError"
        />
        <img
          v-else
          :loading="useLazyImages ? 'lazy' : 'eager'"
          :src="`/_cfi/cdn-cgi/image/format=auto,fit=cover,quality=80,w=264,h=198${photo.url.masterImage}`"
          :srcset="`
            /_cfi/cdn-cgi/image/format=auto,fit=cover,quality=80,w=264,h=198${photo.url.masterImage} 264w,
            /_cfi/cdn-cgi/image/format=auto,fit=cover,quality=70,w=360,h=270${photo.url.masterImage} 360w,
            /_cfi/cdn-cgi/image/format=auto,fit=cover,quality=50,w=720,h=540${photo.url.masterImage} 720w
          `"
          :alt="capitalize(photoCaptionAltFormatter(photo.caption))"
          sizes="33vw"
          width="142"
          height="107"
          @imageLoadingError="handlePhotoLoadingError"
        />
        <template v-if="index == 0">
          <div class="photo-count-fullscreen">
            <img
              src="@/assets/images/photo-icon-white.svg"
              width="17"
              height="17"
              alt=""
              class="photograph icon"
            />
            <i class="photo-count">{{ loadedPhotos.length }}</i>
            <img
              src="@/assets/images/fullscreen.svg"
              width="16"
              height="16"
              alt=""
              class="fullscreen icon"
            />
          </div>
        </template>
      </div>
    </div>

    <client-only>
      <pitch-type-gallery-modal
        :photos="loadedPhotos"
        :fullscreen-modal-hash="fullscreenModalHash"
      />
    </client-only>
  </section>
</template>

<script lang="ts">
import { photoCaptionAltFormatter } from '~/utility/photoCaptionAltFormatter'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { capitalize } from '~/utility/text'
import { PitchTypePhoto } from '../../campsite-details/types'

@Component({
  emits: [],
})
class PitchTypePhotos extends Vue {
  @Prop({ required: true })
  photos: PitchTypePhoto[]

  @Prop({ required: true })
  fullscreenModalHash: string

  @Prop({ default: true })
  useLazyImages: boolean

  loadedPhotos: PitchTypePhoto[] = []

  mounted() {
    this.loadedPhotos = this.photos
  }

  handlePhotoLoadingError(failedToLoadPhotoSrc: string) {
    this.loadedPhotos = this.photos.filter(
      (photo) => photo.url.detailSmall !== failedToLoadPhotoSrc,
    )
  }

  async openFullscreen() {
    await this.$router.push({
      hash: `#${this.fullscreenModalHash}`,
      query: this.$router.currentRoute.value.query,
    })
  }

  capitalize(value: string) {
    return capitalize(value)
  }

  photoCaptionAltFormatter(caption) {
    return photoCaptionAltFormatter(caption)
  }
}

export default toNative(PitchTypePhotos)
</script>

<style scoped>
.photos-row {
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  min-height: 24.75vw;
  background-color: #eef2f7;
}

.photo-wrapper {
  position: relative;
  max-width: calc(100% / 3);
  min-height: 24.75vw;
  border-right: 1px solid white;
}

.photo-wrapper.last {
  border: none;
}

.photo-wrapper > img {
  width: 100%;
  max-width: none;
}

@media screen and (min-width: 320px) and (max-width: 998px) and (orientation: landscape) {
  .photo-wrapper > img {
    width: auto;
  }
}

.photo-count-fullscreen {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 0.25em;
  padding: 0 0.35em 0.25em;
}

.photo-count {
  font-size: var(--body);
  color: white;
  text-shadow: 0 1px 1px rgb(0 0 0 / 40%);
}

.photos-row .photo-count-fullscreen img {
  border-radius: 0 !important;
  filter: drop-shadow(0 1px 1px rgb(0 0 0 / 40%));
}

.fullscreen.icon {
  margin: 0 0 0 auto;
}
</style>
